import api from "@/services/api";

export default {
  fetchData() {
    return api.get(`surveyJSON/`).then(response => response.data);
  },
  updateSurvey(payload) {
    return api.patch(`surveyJSON/${payload.pk}/`, payload).then(response => response.data);
  },
};
